import React, { forwardRef, useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AppContext, isAuthorised, UpgradePlanButton } from '@nile/components';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Heading, CarouselSlider } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';

/**
 * This HOC is written to Wrap the component with Feature gating check
 * @param {ReactComponent} Component
 */
const resourceMap = {
  ALL_TIME_SHEET: {
    imageMap: {
      organizeAndPlan: 'OrganizeAndPlan',
      manageAndOptimize: 'ManageAndOptimize',
      strategizeAndProfit: 'StrategizeAndProfit'
    },
    stepMap: ['organizeAndPlan', 'manageAndOptimize', 'strategizeAndProfit']
  }
};
function FeatureGating(props) {
  const { options, innerRef } = props;
  const intl = useIntl();
  if (!options) {
    throw Error('Options is mandatory');
  }
  const { mode, feature } = options;

  const appContext = useContext(AppContext);
  const allowedFeatures = appContext.planFeatureList;
  console.log({ allowedFeatures });
  console.log({ options });
  if (allowedFeatures[feature]?.enabled) {
    return <props.component ref={innerRef} {...props} />;
  }
  if (mode === 'hide') {
    return '';
  }
  const imageMap = resourceMap[feature].imageMap;
  const stepMap = resourceMap[feature].stepMap;
  const corouselSettings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    dotsClass: 'slick-dots slick-thumb',
    customPaging: function(i) {
      return (
        <a>
          <div className="carousel-text">
            <FormattedMessage
              id={`app.upgrade.${feature}.${imageMap[stepMap[i]]}`}
            />
          </div>
        </a>
      );
    }
  };
  return (
    <Wrapper>
      <Holder>
        <div className="flex col center acenter">
          <HeaderTitle>
            <FormattedMessage id="app.plan.upgrade.title" />
            {/* <FormattedMessage id="UPGRADE PLAN" /> */}
          </HeaderTitle>
          <Description>
            <Heading>
              <FormattedMessage id={`app.plan.upgrade.${feature}`} />
              {/* <FormattedMessage
                id={`Make your profitability skyrocket with org-wide technician and client efficiency insights.`}
              /> */}
            </Heading>
          </Description>
          <div className="mt-10 upgrade-button">
            <UpgradePlanButton />
          </div>
        </div>
        <CarouselHolder>
          <CarouselSlider {...corouselSettings}>
            {['', '', ''].map((item, index) => {
              return (
                <div className="carousel-image">
                  <img
                    src={`${envConfig.imageRoot}svg/${
                      imageMap[stepMap[index]]
                    }.svg`}
                  ></img>
                  {/* {index} */}
                </div>
              );
            })}
          </CarouselSlider>
        </CarouselHolder>
      </Holder>
    </Wrapper>
  );
}

function withFeatureGating(Component, options) {
  return forwardRef((props, ref) => (
    <FeatureGating
      component={Component}
      {...props}
      innerRef={ref}
      options={options}
    />
  ));
}

const Wrapper = styled.div`
  background-image: url(${envConfig.imageRoot}svg/DottedBg.svg);
  height: 100%;
  .Superops-Heading--sizeSecondary {
    font-size: 32px !important;
    line-height: 48px;
    text-align: center;
  }
  .carousel-text {
    width: 200px;
  }
  .slick-dots li {
    width: auto;
    height: 50px !important;
  }
  .carousel-image {
  }
`;

const Holder = styled.div`
  background-image: url(${envConfig.imageRoot}svg/Gradient.svg);
  height: 100%;
  background-repeat: no-repeat;
  background-repeat-x: repeat;
`;

const HeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  margin-top: 20px;
  color: #f05;
`;
const Description = styled.div`
  margin-top: 10px;
  text-align: center;
  width: 800px;
`;

const CarouselHolder = styled.div`
  .carousel-image {
    display: flex !important;
    justify-content: center;
  }
  img {
    width: 75%;
  }
  .slick-dots {
    position: relative;
    margin-bottom: 40px;
  }
  .slick-active .carousel-text {
    color: red;
  }
`;

export default withFeatureGating;
